import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLink = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" }));
const ForwardRef = forwardRef(SvgArrowLink);
export { ForwardRef as ReactComponent };
